export default __webpack_public_path__ + "static/media/15-DoomsdayDeviceDonut.13c43c37.png";